import mem1 from "../imgs/team/mem1.png";
import mem2 from "../imgs/team/mem2.png";
import mem3 from "../imgs/team/mem3.png";
import mem4 from "../imgs/team/mem4.png";
import mem5 from "../imgs/team/mem5.png";
import mem6 from "../imgs/team/mem6.png";
import mem7 from "../imgs/team/mem7.png";
import mem8 from "../imgs/team/mem8.png";
import mem9 from "../imgs/team/mem9.png";
import mem10 from "../imgs/team/mem10.png";

export const TeamData = [
    {
        id: 1,
        name: "Keith Rumjahn",
        role: "Chief Executive Officer",
        avatar: mem1,
    },
    {
        id: 2,
        name: "Andy Hall",
        role: "Head of Group Operations",
        avatar: mem2,
    },
    {
        id: 3,
        name: "Keith Chan",
        role: "Head of Engineering",
        avatar: mem3,
    },
    {
        id: 4,
        name: "Kenneth Chau",
        role: "Software Engineer",
        avatar: mem4,
    },
    {
        id: 5,
        name: "Kan Kong",
        role: "Software Engineer",
        avatar: mem5,
    },
    {
        id: 6,
        name: "Sum Yeung",
        role: "Software Engineer",
        avatar: mem6,
    },
    {
        id: 7,
        name: "Carol Lee",
        role: "Senior Lead Game Artist",
        avatar: mem7,
    },
    {
        id: 8,
        name: "Elaine Leung",
        role: "UX/UI Designer",
        avatar: mem8,
    },
    {
        id: 9,
        name: "Joey Wong",
        role: "Project Manager",
        avatar: mem9,
    },
    {
        id: 10,
        name: "Connie Yeh",
        role: "Digital Marketing Executive",
        avatar: mem10,
    },
];

export const AdvisorData = [
    {
        name: "Yat Siu",
        des: "Chairman of the Board, Animoca Brands",
    },
    {
        name: "Sonny Vu",
        des: "Chief Executive Officer,AREVO",
    },
    {
        name: "Dylan Boyd",
        des: "Director, New Programs Development, R/GA Ventures",
    },
    {
        name: "Jeremiah Owyang",
        des: "Industry Analyst & Founding Partner, Kaleido Insights Team",
    },
    {
        name: "James Ho",
        des: "Director of Strategic Partnerships, Animoca Brands",
    },
    {
        name: "Sean Dudley",
        des: "VP of Product, Animoca Brands",
    },
    {
        name: "Jacky Yuk",
        des: "Managing Architect, Animoca Brands",
    },
];
